interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const FigmaSettingIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      cursor='pointer'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 8C13.9998 7.63218 13.9664 7.26512 13.9 6.90333L15.9287 5.73333L13.9287 2.26667L11.8993 3.43933C11.339 2.95995 10.6952 2.58796 10 2.342V0H6V2.342C5.30484 2.58796 4.66097 2.95995 4.10067 3.43933L2.07133 2.26667L0.0713331 5.73333L2.1 6.90333C1.96674 7.62837 1.96674 8.37163 2.1 9.09667L0.0713331 10.2667L2.07133 13.7333L4.10067 12.5613C4.66102 13.0405 5.30489 13.4122 6 13.658V16H10V13.658C10.6952 13.412 11.339 13.04 11.8993 12.5607L13.9287 13.7333L15.9287 10.2667L13.9 9.09667C13.9664 8.73488 13.9998 8.36782 14 8ZM10 8C10 8.39556 9.8827 8.78224 9.66294 9.11114C9.44318 9.44004 9.13082 9.69638 8.76537 9.84776C8.39991 9.99913 7.99778 10.0387 7.60982 9.96157C7.22186 9.8844 6.86549 9.69392 6.58579 9.41421C6.30608 9.13451 6.1156 8.77814 6.03843 8.39018C5.96126 8.00222 6.00087 7.60009 6.15224 7.23463C6.30362 6.86918 6.55996 6.55682 6.88886 6.33706C7.21776 6.1173 7.60444 6 8 6C8.53043 6 9.03914 6.21071 9.41421 6.58579C9.78929 6.96086 10 7.46957 10 8Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaSettingIcon;
